import { ActionCardData, sectionTypes } from '@playbooks/action-cards-utils/src'

export const lockVisibleHeaders = (card: ActionCardData, headers: number | null) => {
  let headersIndex = 0
  card.sections.forEach(sec => {
    if (sec.type === sectionTypes.SEPARATOR) {
      if (!headers || headersIndex < headers) {
        sec.isLocked = true
      }
      headersIndex++
    }
  })
}

export const saveDispatcher: {
  saveCallback: ((data: ActionCardData, oldData: ActionCardData | null) => void) | undefined
} = {
  saveCallback: () => {},
}
